import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { NearbyTokenExportAdapter, TokenExportAdapter } from './TokenExports';
import { tokenTool } from './TokenTool';
import { tokenToolboxItem } from './TokenToolboxItem';

export class TokenPackage implements Package {

    public install = (host: PackageHost) => host
        .plug(inExportAdapter(NearbyTokenExportAdapter))
        .plug(inExportAdapter(TokenExportAdapter))
        .plug(inTool(tokenTool))
        .plug(inToolboxItems(tokenToolboxItem))
        ;
}

// export const createToken = defineCommand(
//     'createToken',
//     'Create: Token',
//     (r) => {
//         createAtCameraPosition(r, Token, nc => {
//             const hu = Math.random() * 360;
//             nc.width = 150;
//             nc.height = 150;
//             nc.background = hsl(hu * 360, .8, .61);
//         });
//     },
// );
